import moment from "moment";
import React from "react";
import { useEffect, useState } from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import RightArrowLongIcon from "../assets/right-arrow-long.svg";
import LengendContainer from "./LengendContainer";
import { useSelector } from "react-redux";
import { colorMap, getTickIntervals, graphType } from "../utils/constants";
import HC_Regression from "highcharts-regression";
import NoDataFound from "./NoDataFound";

// usage of highcharts-regression
HC_Regression(Highcharts);

const AverageEngineLoadChart = ({ data, filterType }) => {
  const isSidemenuExpanded = useSelector(
    (state) => state.mainReducer.isSidemenuExpanded
  );
  const [odometerTick, setOdometerTick] = useState([]);

  const [chartData, setChartData] = useState(null);
  const [engineLoadArray, setEngineLoadArray] = useState(null);
  const [chartInfo, setChartInfo] = useState(null);
  const [month, setMonth] = useState(null);
  const [year, setYear] = useState(null);
  useEffect(() => {
    setChartData(data?.engineLoadPercentage);
    if (data && data?.engineLoadPercentage.length > 0) {
      let engineLoadArray = [];

      switch (filterType) {
        case graphType.DATE: {
          engineLoadArray = data.engineLoadPercentage.map((item) => [
            moment(item.statsDate).format("DD"),
            item.engineLoadPercentage,
          ]);
          break;
        }
        case graphType.TRIP: {
          engineLoadArray = data.engineLoadPercentage.map((item) => [
            item.trip,
            item.engineLoadPercentage,
          ]);
          break;
        }
        case graphType.MILES: {
          engineLoadArray = data.engineLoadPercentage.map((item) => [
            item.odometer,
            item.engineLoadPercentage,
          ]);
          if (engineLoadArray.length > 1) {
            const tickArray = data.engineLoadPercentage
              .map((item) => item.odometer)
              .sort((a, b) => a - b);
            const tArray = getTickIntervals(tickArray);
            setOdometerTick(tArray);
          }
          break;
        }
        default: {
          engineLoadArray = data.engineLoadPercentage.map((item) => [
            moment(item.statsDate).format("DD"),
            item.engineLoadPercentage,
          ]);
        }
      }

      setChartInfo(data?.information);
      setEngineLoadArray(engineLoadArray);
      const month = moment(data?.engineLoadPercentage[0].statsDate).format(
        "MMMM"
      );
      const year = moment(data?.engineLoadPercentage[0].statsDate).format(
        "YYYY"
      );
      setMonth(month);
      setYear(year);
    } else {
      setEngineLoadArray(null);
    }
  }, [data]);

  const options = {
    chart: {
      backgroundColor: "#FFFFFF",
      spacing: [50, 30, 30, 20],
      height: 350,
      type: "scatter",
      // borderColor: "#CECECE",
      borderRadius: 20,
      // borderWidth: 1,
      events: {
        load: function () {
          this.series[1]?.update({
            enableMouseTracking: false,
          });
        },
      },
      style: {
        position: "relative",
      },
    },
    title: {
      text: null,
    },
    yAxis: {
      title: {
        useHTML: true,
        text: `
        <div style="font-size: 11px; left:-140px;top:4px;position:absolute;">
         Average Engine Load
          <img src='${RightArrowLongIcon}'/>
        </div>
        `,
        align: "high",
      },
      min: 0,
      labels: {
        style: {
          color: "#353536",
          lineHeight: 1,
          font: "10px Open Sans",
          letterSpacing: "1px",
        },
      },
      gridLineColor: "#F2F2F2",
    },
    xAxis: {
      type: "category",
      tickPositions: filterType === graphType.MILES ? odometerTick : null,
      title: {
        useHTML: true,
        text: `
        <div style= "font-size: 11px; left:-60px;top:4px;position:absolute;">
           ${
             filterType === graphType.DATE
               ? `${month},${year}`
               : filterType === graphType.MILES
               ? `Miles`
               : filterType === graphType.TRIP
               ? `Trips`
               : `${month},${year}`
           }
          <img src='${RightArrowLongIcon}'/>
        </div>
        `,
        align: "high",
      },
      labels: {
        style: {
          color: "#353536",
          lineHeight: 1,
          font: "10px Open Sans",
          letterSpacing: "1px",
        },
      },
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      series: {
        label: {
          connectorAllowed: true,
        },
        marker: {
          radius: 3,
        },
      },
    },
    tooltip: {
      backgroundColor:"#000",
      style: {
        color: "#FFFFFF",
        font: "12px Open Sans",
      },
    },
    series: [
      {
        data: engineLoadArray,
        regression: engineLoadArray?.length > 1 ? true : false,
        regressionSettings: {
          type: "polynomial",
          order: "2",
          color: chartInfo && colorMap[chartInfo[0]?.color],
          // legend: "%eq",
          // name: "%eq | r2: %r",
          dashStyle: "dot",
        },
        showInLegend: false,
        name: "Average Engine Load (%)",
        color: chartInfo && colorMap[chartInfo[0]?.color],
      },
    ],
  };

  return (
    <div key={engineLoadArray}>
      <div key={isSidemenuExpanded}>
        {Array.isArray(engineLoadArray) && engineLoadArray.length > 0 ? (
          <>
            <LengendContainer chartInfo={chartInfo} />
            <HighchartsReact highcharts={Highcharts} options={options} />
            <div
              style={{ width: "100%", textAlign: "center", paddingTop: "10px" }}
            >
              <p style={{ fontSize: "14px", fontWeight: "600" }}>
                Average Engine Load (%)
              </p>
            </div>
          </>
        ) : (
          <>
            <NoDataFound chartName=" Average Engine Load (%)" />
          </>
        )}
      </div>
    </div>
  );
};

export default AverageEngineLoadChart;
